export const BOND_PAID_OFF = 'Bond paid off';
export const TRACE_DEBUG = 1;
export const TRACE_INFO = 2;
export const TRACE_WARN = 3;
export const TRACE_ERROR = 4;
